// Shared Google Maps styling used across every map surface (live map, route
// replay, distance/route debug, geofence debug, location pickers) so they all
// share one dark treatment and read as part of the dark app instead of a bright
// rectangle. Hex is inherent to Google Maps style JSON — src/components/Maps/ is
// allowlisted by the no-raw-hex-color lint rule. Values track the Tread deep-black
// surface ramp and neutral grey ramp (see src/theme/semanticTokens.ts).

// POI labels are hidden in both modes to reduce clutter.
const HIDE_POI_LABELS: google.maps.MapTypeStyle[] = [
  { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
];

const DARK_MAP_STYLES: google.maps.MapTypeStyle[] = [
  { elementType: 'geometry', stylers: [{ color: '#0a1820' }] }, // semantic.surface
  { elementType: 'labels.text.stroke', stylers: [{ color: '#0a1820' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#8b969c' }] }, // treadGray4 (dark)
  ...HIDE_POI_LABELS,
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#13242e' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#2a3942' }] },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#a0abb1' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#3a4a54' }],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [{ color: '#4e606a' }],
  },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#13242e' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#06121a' }] }, // surfaceSunken
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#4e606a' }],
  },
];

/**
 * Returns the map style array for the active mode. Satellite/hybrid imagery must
 * never be recolored, so callers pass `isImageryView` to fall back to the plain
 * (POI-hidden) style there.
 */
export function getMapStyles(isDark: boolean, isImageryView = false) {
  return isDark && !isImageryView ? DARK_MAP_STYLES : HIDE_POI_LABELS;
}
